import { render, staticRenderFns } from "./menu-views.vue?vue&type=template&id=6965c728"
import script from "./menu-views.vue?vue&type=script&lang=js"
export * from "./menu-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports